// Sends the inner form's email to a Klaviyo list via the public client subscriptions API, then shows the success message inline.
class KlaviyoSignup extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const form = this.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', (event) => this.#submit(event, form), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  async #submit(event, form) {
    const companyId = (this.dataset.companyId || '').trim();
    const listId = (this.dataset.listId || '').trim();
    // Without Klaviyo IDs the native Shopify customer form submits as usual.
    if (!companyId || !listId) return;

    event.preventDefault();
    const email = form.querySelector('input[type="email"]')?.value.trim();
    if (!email) return;

    this.setAttribute('aria-busy', 'true');
    const error = this.querySelector('[data-signup-error]');
    if (error) error.hidden = true;

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: this.dataset.source || 'Countdown page',
              profile: { data: { type: 'profile', attributes: { email } } },
            },
            relationships: { list: { data: { type: 'list', id: listId } } },
          },
        }),
      });
      if (!response.ok) throw new Error(String(response.status));

      // Also keep a Shopify customer record; failures here never block the Klaviyo signup.
      fetch(form.action, { method: 'POST', body: new FormData(form) }).catch(() => {});

      const fields = this.querySelector('[data-signup-fields]');
      const success = this.querySelector('[data-signup-success]');
      if (fields) fields.hidden = true;
      if (success) success.hidden = false;
    } catch {
      if (error) error.hidden = false;
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

customElements.define('s-klaviyo-signup', KlaviyoSignup);
